var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import h from "../helper/helper";
import Observer from "../asset/observer";
import * as Bluebird from "bluebird";
import errorService from "../services/error.service";
import socket from "../services/socket.service";
import Cache from "../services/Cache";
import sessionService from "../services/session.service";
var initService = require("services/initService");
import ChunkLoader from "../messages/chatChunk";
import ChatLoader from "../messages/chat";
import MessageLoader from "../messages/message";
import ChatListLoader from "../messages/chatList";
new Cache("messageSend").deleteAll();
var activeChat = 0;
var messageService = {
    notify: null,
    allChatsLoaded: false,
    prependChatID: function (chatID) {
        if (!ChatListLoader.isLoaded(sessionService.getUserID())) {
            return;
        }
        var chatList = ChatListLoader.getLoaded(sessionService.getUserID());
        var chatIDs = chatList.get();
        chatList.set([
            chatID
        ].concat(chatIDs.filter(function (id) { return id !== chatID; })));
    },
    addSocketData: function (data) {
        var _this = this;
        if (!data) {
            return Bluebird.resolve();
        }
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var chat, chunk, chat, chunk, chat, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.chat) return [3 /*break*/, 2];
                        console.warn("Add chat");
                        return [4 /*yield*/, ChatLoader.load(data.chat)];
                    case 1:
                        chat = _a.sent();
                        messageService.prependChatID(chat.getID());
                        _a.label = 2;
                    case 2:
                        if (!data.chunk) return [3 /*break*/, 5];
                        console.warn("Add chunk");
                        return [4 /*yield*/, ChunkLoader.load(data.chunk)];
                    case 3:
                        chunk = _a.sent();
                        return [4 /*yield*/, ChatLoader.get(chunk.getChatID())];
                    case 4:
                        chat = _a.sent();
                        chat.addChunkID(chunk.getID());
                        messageService.prependChatID(chat.getID());
                        _a.label = 5;
                    case 5:
                        if (!data.message) return [3 /*break*/, 9];
                        console.warn("Add message");
                        return [4 /*yield*/, ChunkLoader.get(data.message.server.chunkID)];
                    case 6:
                        chunk = _a.sent();
                        return [4 /*yield*/, ChatLoader.get(chunk.getChatID())];
                    case 7:
                        chat = _a.sent();
                        return [4 /*yield*/, MessageLoader.load(data.message)];
                    case 8:
                        message = _a.sent();
                        chat.addMessage(message);
                        if (!message.isOwn()) {
                            chat.addUnreadMessage(message.getServerID());
                        }
                        else if (chat.getLatestMessage() === message.getClientID()) {
                            chat.localMarkRead();
                        }
                        messageService.prependChatID(chat.getID());
                        messageService.notify({ message: message, chat: chat, chunk: chunk }, "message");
                        _a.label = 9;
                    case 9: return [4 /*yield*/, Bluebird.resolve()];
                    case 10:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    },
    getChatIDs: function () {
        var myID = sessionService.getUserID();
        if (!ChatListLoader.isLoaded(myID)) {
            return [];
        }
        return ChatListLoader.getLoaded(myID).get();
    },
    setActiveChat: function (_activeChat) {
        activeChat = _activeChat;
    },
    isActiveChat: function (chatID) {
        return chatID === activeChat;
    },
    loadMoreChats: h.cacheUntilSettled(function (count) {
        if (count === void 0) { count = 20; }
        return initService.awaitLoading().then(function () {
            return ChatListLoader.get(sessionService.getUserID());
        }).then(function () {
            var unloadedChatIDs = messageService.getChatIDs().filter(function (chatID) {
                return !ChatLoader.isLoaded(chatID);
            });
            if (unloadedChatIDs.length === 0) {
                messageService.allChatsLoaded = true;
            }
            return unloadedChatIDs.slice(0, count);
        }).map(function (chatID) {
            return ChatLoader.get(chatID);
        });
    }),
    sendUnsentMessages: function () {
        var unsentMessages = new Cache("unsentMessages", { maxEntries: -1, maxBlobSize: -1 });
        return unsentMessages.all().map(function (unsentMessage) {
            var data = JSON.parse(unsentMessage.data);
            return messageService.getChat(data.chatID).then(function (chat) {
                return chat.sendUnsentMessage(data, unsentMessage.blobs);
            });
        });
    },
    getChat: function (chatID, cb) {
        return Bluebird.try(function () {
            return ChatLoader.get(chatID);
        }).nodeify(cb);
    },
    getUserChat: function (userID, cb) {
        return initService.awaitLoading().then(function () {
            return socket.definitlyEmit("chat.getChatWithUser", {
                userID: userID
            });
        }).then(function (data) {
            if (data.chatID) {
                return data.chatID;
            }
            return false;
        }).nodeify(cb);
    }
};
Observer.extend(messageService);
socket.channel("notify.chat", function (e, data) {
    if (!e) {
        messageService.addSocketData(data);
    }
    else {
        errorService.criticalError(e);
    }
});
initService.awaitLoading().then(function () {
    messageService.sendUnsentMessages();
});
export default messageService;



//////////////////
// WEBPACK FOOTER
// ./js/messages/messageService.ts
// module id = null
// module chunks = 